<template>
<div class="mfc-form-input-container mfc-tags-input-wrapper mfc-tags-input-wrapper">
    <label for="tag-input" >Tags </label>
    <div class="mfc-tags-input">
        <span class="[ mcc-chip mcc-chip--primary ] [ mfc-tags-input__chip ]" tag-input="true" v-for="(tag, index) in tags" :key="index">
            <span class="mcc-chip__label">{{ tag }}</span>
            <button v-if="!disabled" class="mcc-chip__action" type="button" aria-label="Remove Chip" @click="removeTag(index)">
                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon>
            </button>
        </span>
        <input type="text" id="tags" class="mfc-tags-input__input" :class="{'ms-is-invalid': invalidText.trim().length != 0}" @input="invalidText = ''" @keydown.enter="addTag" :disabled="disabled" maxlength="50"/>
    </div>
    <div v-if="invalidText.trim().length != 0" id="mds_text_feedback" class="[ mfc-invalid-feedback mfc-invalid-feedback--show ]">
        <span>{{ invalidText }}</span>
    </div>
</div>
</template>

<script>

export default {
    name: 'TagInput',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        labels: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            tags: [],
            value: "",
            invalidText: "",
        }
    },
    created() {
        this.tags = [...this.labels];
    },
    watch: {
        labels(newLabels) {
            this.tags = [...newLabels];
        },
        tags(newTags) {
            this.value = newTags.join(',');
        }
    },
    methods: {
        addTag(event) {
            event.preventDefault();
            let val = event.target.value.trim();
            if (val.length > 0) {
                this.tags.push(val);
                event.target.value = '';
            }
        },
        removeTag(index) {
            this.tags.splice(index, 1);
            this.invalidText = "";
        },
    }
}
</script>
<style scoped>
.mfc-tags-input-wrapper .mfc-tags-input__chip { 
    text-transform: none;
}
</style>
